import React, {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../_metronic/helpers'
import ReactPaginate from 'react-paginate'
import {useDispatch, useSelector} from 'react-redux'
import moment from 'moment-timezone'
import {AuthenticateUser} from '../Utils/_helpers/RoleAndPermission'
import {GetAllData} from '../pages/UserPages/Contacts/AllContactsList/SubscriberSlice/SubscriberSlice'
import {
  getCampaignContacts,
  getSegmentTagsList,
  getTotalCount,
} from '../pages/UserPages/new-message/BulkMessageSlice/BulkMessageSlice'
import {useGetAllSegmentsQuery, useGetAllTagsQuery} from '../../services/cellcast'

const ContectSegmentListsPopup = ({show, handleClose, selectedData}: any) => {
  const dispatch = useDispatch()
  const groupid: any = useSelector((state: any) => state?.subscriberData?.FieldName?.data?._id)
  const dbOptions: any[] = useSelector(
    (state: any) => state?.subscriberData?.FieldName?.data?.fields
  )
  const subscriberData = useSelector(getSegmentTagsList)
  const totalContact: any = useSelector(getTotalCount)

  const subscriberList = subscriberData?.reduce((accumulator: any, current: any) => {
    if (!accumulator.some((item: any) => item.number === current.number)) {
      accumulator.push(current)
    }
    return accumulator
  }, [])

  const {isLoading: loadingTags, data: tags} = useGetAllTagsQuery({})
  const {isLoading: loadingSegment, data: segments} = useGetAllSegmentsQuery({})

  const [page, setPage] = useState<any>({
    page: 1,
    size: 10,
    search: '',
  })

  useEffect(() => {
    const filterData = {
      page: page.page,
      size: page.size,
      search: page.search,
    }
    if (!!selectedData) {
      dispatch(getCampaignContacts({to: {...selectedData}, page: filterData}))
    }
  }, [selectedData, page.page, page.size])

  const checkField = () => {
    let fields = ['First Name', 'Full Name', 'Last Name']
    if (dbOptions?.find((val: any) => fields.includes(val)) == undefined) {
      return false
    } else {
      return true
    }
  }

  const getTagsByIDs = (tagIds: string[]) => {
    if (Array.isArray(tagIds) && tagIds.length === 0) {
      return []
    }

    if (typeof tagIds[0] !== 'string') {
      return tagIds
    }

    let tmpTags: any[] = []
    tagIds.forEach((el) => {
      if (tags && tags.data && Array.isArray(tags.data)) {
        const foundTag = tags.data.find((f: any) => f._id === el)
        if (foundTag) {
          tmpTags.push(foundTag)
        }
      }
    })
    return tmpTags
  }

  const pageCount = Math.ceil((totalContact?.totalContactCount || 0) / page.size);


  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-950px'
        className='vh-100'
        show={show}
        onHide={handleClose}
      >
        <div className='modal-header'>
          <h2>Contacts List</h2>
          <div className='btn btn-icon btn-sm' onClick={handleClose}>
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
        </div>
        <div className='modal-body p-10 pt-5'>
          <div className='card-body pt-2'>
            <div className='tab-content'>
              <div
                className='table-responsive'
                style={{msOverflowStyle: 'none', scrollbarWidth: 'none'}}
              >
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead>
                    <tr className='fw-bold text-muted text-uppercase'>
                      <th>Mobile</th>
                      <th style={{minWidth: 150}}>Tags & List</th>
                      <th>Status</th>
                      {checkField() && dbOptions?.includes('First Name') && <th>First Name</th>}
                      {checkField() && dbOptions?.includes('Last Name') && <th>Last Name</th>}
                      {checkField() && dbOptions?.includes('Full Name') && <th>Full Name</th>}

                      {dbOptions?.map((val: any, i: number) => {
                        if (!['First Name', 'Full Name', 'Last Name']?.includes(val)) {
                          return <th key={i}>{val}</th>
                        }
                      })}

                      <th>Date Added</th>
                    </tr>
                  </thead>
                  <tbody className='text-gray-600'>
                    {subscriberList?.map((val: any, i: number) => (
                      <tr key={i}>
                        <td>
                          <b>{val?.number}</b>
                        </td>
                        <td
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          title={val?.tags
                            ?.filter((key: any) => key?.isHidden === false)
                            ?.map((key: any) => key?.name)
                            .join()}
                        >
                          <div className='d-flex gap-2 align-items-center flex-wrap'>
                            {getTagsByIDs(val?.tags)
                              ?.filter((data: any) => !data?.isHidden)
                              ?.map(
                                (data: {_id: string; name: string; color: string}, i: number) => (
                                  <div
                                    key={i}
                                    className='inbox-tags'
                                    style={{
                                      color: data?.color ? 'white' : 'black',
                                      backgroundColor: data?.color ? data?.color : '',
                                    }}
                                  >
                                    {data?.name}
                                  </div>
                                )
                              )}
                          </div>
                        </td>
                        <td>
                          {val?.contact?.isBlockedByUser || val?.contact?.isBlocked
                            ? 'Unsubscribed'
                            : 'Subscribed'}
                        </td>
                        {dbOptions?.includes('First Name') &&
                          (val?.fields?.findIndex((val: any) => val?.name === 'First Name') !==
                          -1 ? (
                            <td>
                              {
                                val?.fields?.[
                                  val?.fields?.findIndex((val: any) => val?.name === 'First Name')
                                ]?.value
                              }
                            </td>
                          ) : (
                            <td>-</td>
                          ))}
                        {dbOptions?.includes('Last Name') &&
                          (val?.fields?.findIndex((val: any) => val?.name === 'Last Name') !==
                          -1 ? (
                            <td>
                              {
                                val?.fields?.[
                                  val?.fields?.findIndex((val: any) => val?.name === 'Last Name')
                                ]?.value
                              }
                            </td>
                          ) : (
                            <td>-</td>
                          ))}
                        {dbOptions?.includes('Full Name') &&
                          (val?.fields?.findIndex((val: any) => val?.name === 'Full Name') !==
                          -1 ? (
                            <td>
                              {
                                val?.fields?.[
                                  val?.fields?.findIndex((val: any) => val?.name === 'Full Name')
                                ]?.value
                              }
                            </td>
                          ) : (
                            <td>-</td>
                          ))}

                        {dbOptions?.map((Fields: any, i: number) => {
                          let check = val?.fields?.map((key: any) => key?.name)
                          if (!['First Name', 'Full Name', 'Last Name']?.includes(Fields)) {
                            if (check?.includes(Fields)) {
                              return (
                                <td key={i}>
                                  {val?.fields?.find((key: any) => key?.name == Fields)?.value}
                                </td>
                              )
                            } else {
                              return <td key={i}>--</td>
                            }
                          }
                        })}

                        <td>{moment(val?.createdAt).format('DD/MM/YYYY')}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className='abcd '>
                  <select onChange={(e: any) => setPage({...page, size: e.target.value, page: 1})}>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={250}>250</option>
                  </select>
                  <ReactPaginate
                    previousLabel='<'
                    nextLabel='>'
                    pageCount={pageCount}
                    onPageChange={(e: any) => setPage({...page, page: e.selected + 1})}
                    containerClassName={'pagiantion'}
                    previousLinkClassName={'pagination__link'}
                    nextLinkClassName={'pagination__link'}
                    disabledClassName={'pagination__link--disabled'}
                    activeClassName={'pagination__link--active'}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className='d-flex justify-content-end mt-10'>
            <button
              onClick={handleClose}
              className='btn btn-sm btn-light btn-primary fw-500 p-3 px-7 border border-primary'
            >
              <span className='indicator-label'>Close</span>
            </button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default ContectSegmentListsPopup
